import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    icons: {
      iconfont: 'mdiSvg'
    },
    themes: {
      light: {
        primary: '#980002',
        secondary: '#B74D4E',
        accent: '#850001',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }

  }
})
